import { useSizeTypes } from 'contexts';
import { FC, useMemo } from 'react';
import { ActiveUnit, EquipmentType } from 'types';

export const ContainerDetails: FC<{ units: ActiveUnit[] }> = ({ units }) => {
  const container = useMemo(() => {
    return units.find(({ equipmentType }) => equipmentType === EquipmentType.CONTAINER);
  }, [units]);

  const { isReefer: isReeferCode } = useSizeTypes();
  const isReefer = useMemo(() => isReeferCode(container?.sizeType), [isReeferCode, container?.sizeType]);

  return !container ? null : (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>CONTAINER DETAILS</h4>
      </div>
      <div className="card-body">
        <div className={`grid-${!isReefer ? 5 : 4} p-2`}>
          <div>
            <h6 className="text-dark font-weight-regular">LOADED</h6>
            <p className="text-black" data-cy="container-loaded">
              {!container.loaded ? 'NO' : 'YES'}
            </p>
          </div>
          <div>
            <h6 className="text-dark font-weight-regular">SEAL #1</h6>
            <p className="text-black" data-cy="container-seal-0">
              {container.seal0 ?? 'N/A'}
            </p>
          </div>
          <div>
            <h6 className="text-dark font-weight-regular">SEAL #2</h6>
            <p className="text-black" data-cy="container-seal-1">
              {container.seal1 ?? 'N/A'}
            </p>
          </div>
          <div>
            <h6 className="text-dark font-weight-regular">SEAL #3</h6>
            <p className="text-black" data-cy="container-seal-2">
              {container.seal2 ?? 'N/A'}
            </p>
          </div>
          <div>
            <h6 className="text-dark font-weight-regular">HAZARD</h6>
            <p className="text-black" data-cy="container-hazard">
              {!container.hazard ? 'NO' : 'YES'}
            </p>
          </div>
          {!isReefer ? null : (
            <>
              <div>
                <h6 className="text-dark font-weight-regular">TEMPERATURE</h6>
                <p className="text-black" data-cy="container-temperature">
                  {typeof container.temperature !== 'number' ? 'N/A' : `${container.temperature}°C`}
                </p>
              </div>
              <div>
                <h6 className="text-dark font-weight-regular">HUMIDITY</h6>
                <p className="text-black" data-cy="container-humidity">
                  {typeof container.humidity !== 'number' ? 'N/A' : `${container.humidity}%`}
                </p>
              </div>
              <div>
                <h6 className="text-dark font-weight-regular">VENTILATION</h6>
                <p className="text-black" data-cy="container-ventilation">
                  {container.ventilation ?? 'N/A'}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
